const handleSamlPassthrough = async authURI => {
  const agentToken = authURI.split("/").pop();
  const response = await fetch(authURI, {
    method: "GET",
    credentials: "include",
    headers: {
      Accept: "application/xml",
      "X-Crippled-Client": "yes"
    }
  });

  const { status, ok } = response;
  if (!ok) throw new Error(status);

  const xml = await response.text();

  if (!/<Identity/.test(xml) || !/<user/.test(xml)) {
    throw new Error("Invalid SAML data");
  }

  return {
    identity: /(<Identity)(.*?)(<\/Identity>)/.exec(xml)[0],
    pxServerUser: /(<user)(.*?)(<\/user>)/.exec(xml)[0],
    agentToken,
    loginType: "SAML"
  };
};

export default handleSamlPassthrough;
